import { Box } from '@mui/material';

import PacketSessionsHistoryPage from 'modules/home/upload-documents/upload-history/PacketSessionsHistoryPage';
import UploadPage from 'modules/home/upload-documents/upload-packet/Main';
import { HeadTag } from 'shared/components';
import { ReactElement, useState } from 'react';
import TypographyLevel from 'shared/components/Typography';

/**
 * IndexUploadPackets component for managing upload packets and sessions history.
 * @param {IndexUploadPacketsProps} props - The component props.
 * @returns {ReactElement} - The rendered component.
 */
const IndexUploadPackets = (): ReactElement => {
    const [activeState, setActiveState] = useState<boolean>(true);

    /**
     * Handles the click event on the upload packet box.
     */
    const handleUploadPacketClick = (): void => {
        setActiveState(true);
    };

    /**
     * Handles the click event on the sessions history box.
     */
    const handleSessionsHistoryClick = (): void => {
        setActiveState(false);
    };

    return (
        <Box className="fluid-container-upload-page">
            <HeadTag title="Upload Cross Check" />
            <Box
                className="box-header-upload-page"
                role="tablist"
                aria-label="Uploading tabs"
            >
                <Box
                    className={
                        activeState
                            ? 'box-content-active-upload-page'
                            : 'box-content-upload-page'
                    }
                    onClick={handleUploadPacketClick}
                    id="tab-upload-page"
                    role="tab"
                    aria-controls="upload-page"
                    aria-selected={activeState ? 'true' : 'false'}
                >
                    <Box>
                        <TypographyLevel
                            variant="four"
                            sx={{
                                ...(activeState
                                    ? { color: '#1E56DA', fontWeight: 'bold' }
                                    : undefined),
                                cursor: 'pointer',
                                padding: '30px',
                            }}
                        >
                            Upload New Cross Check
                        </TypographyLevel>
                    </Box>
                </Box>
                <Box
                    className={
                        !activeState
                            ? 'box-content-active-upload-page'
                            : 'box-content-upload-page'
                    }
                    onClick={handleSessionsHistoryClick}
                    id="tab-history-page"
                    role="tab"
                    aria-controls="history-page"
                    aria-selected={activeState ? 'false' : 'true'}
                >
                    <Box>
                        <TypographyLevel
                            variant="four"
                            sx={{
                                ...(!activeState
                                    ? { color: '#1E56DA', fontWeight: 'bold' }
                                    : undefined),
                                cursor: 'pointer',
                                padding: '30px',
                            }}
                        >
                            Upload Sessions History
                        </TypographyLevel>
                    </Box>
                </Box>
            </Box>
            <Box
                id={activeState ? 'upload-page' : 'history-page'}
                className={
                    !activeState
                        ? 'content-active-container-upload-page'
                        : 'content-container-upload-page'
                }
                role="tabpanel"
                aria-labelledby={
                    activeState ? 'tab-upload-page' : 'tab-history-page'
                }
            >
                {activeState ? (
                    <UploadPage setActiveState={setActiveState} />
                ) : (
                    <PacketSessionsHistoryPage />
                )}
            </Box>
        </Box>
    );
};

export default IndexUploadPackets;
